import { sizes } from "../utils";
import type { MontaSVGProps } from "../types";
const Instagram = ({
  size = "medium",
  color = "inherit",
  ...props
}: MontaSVGProps) => {
  const computedSize = sizes[size] || size;
  props.style = {
    ...props.style,
    color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      viewBox="0 0 24 24"
      width={computedSize}
      height={computedSize}
      {...props}
    >
      <g fill="#fff" clipPath="url(#Instagram_svg__a)">
        <path d="M11.657 2.573c3.071 0 3.434 0 4.646.067.73.008 1.453.141 2.138.395.499.185.95.479 1.32.86.382.371.676.822.86 1.321a6.3 6.3 0 0 1 .396 2.138c.056 1.212.067 1.575.067 4.646s0 3.434-.067 4.646a6.3 6.3 0 0 1-.395 2.138 3.82 3.82 0 0 1-2.181 2.18 6.3 6.3 0 0 1-2.138.396c-1.212.056-1.575.067-4.646.067s-3.434 0-4.646-.067a6.3 6.3 0 0 1-2.138-.395 3.56 3.56 0 0 1-1.32-.86 3.56 3.56 0 0 1-.86-1.321 6.3 6.3 0 0 1-.396-2.138C2.241 15.434 2.23 15.071 2.23 12s0-3.434.067-4.646c.008-.73.141-1.453.395-2.138.185-.499.479-.95.86-1.32.371-.382.822-.676 1.321-.86a6.3 6.3 0 0 1 2.138-.396c1.212-.056 1.575-.067 4.646-.067m0-2.073C8.545.5 8.142.514 6.922.57c-.955.02-1.9.203-2.793.542A5.87 5.87 0 0 0 .76 4.467a8.4 8.4 0 0 0-.533 2.798C.171 8.485.157 8.888.157 12s.014 3.515.07 4.735c.02.955.203 1.9.542 2.793a5.87 5.87 0 0 0 3.355 3.369 8.4 8.4 0 0 0 2.792.54c1.226.063 1.63.063 4.741.063 3.112 0 3.518 0 4.74-.07a8.4 8.4 0 0 0 2.793-.541 5.87 5.87 0 0 0 3.364-3.356 8.4 8.4 0 0 0 .54-2.792c.063-1.226.063-1.63.063-4.741 0-3.112 0-3.518-.07-4.74a8.4 8.4 0 0 0-.541-2.793 5.87 5.87 0 0 0-3.356-3.364A8.4 8.4 0 0 0 16.392.57C15.172.514 14.77.5 11.657.5" />
        <path d="M11.655 6.098a5.904 5.904 0 1 0 0 11.808 5.904 5.904 0 0 0 0-11.808m0 9.74a3.834 3.834 0 1 1 3.834-3.836 3.837 3.837 0 0 1-3.834 3.834zM17.795 7.24a1.38 1.38 0 1 0 0-2.76 1.38 1.38 0 0 0 0 2.76" />
      </g>
      <defs>
        <clipPath id="Instagram_svg__a">
          <path fill="#fff" d="M.157.5h23v23h-23z" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default Instagram;
